























import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { StoreState } from '../../../store';
import vSelect from 'vue-select';
import { connect } from 'net';
import VueElementLoading from 'vue-element-loading';


@Component({
    computed: {
        ...mapState({
          'extensionsList': (state: StoreState) => state.reports.filters.extensionsList,//
          'extensionsList_selectAll': (state: StoreState) => state.reports.filters.extensionsList_selectAll, 
    })
    },
    components: {
        vSelect,VueElementLoading
    },
    
    
})
export default class ExtensionsFilter extends Vue {

    extensionsList!: any[];
    
   

    data() {  
        return {
            selectAll: false,
            selected: [],
            activeCategories:false,
             checked:false
        };
    }

 
   get selectAll_Extn(){
      // return (this as any).extensionsList_selectAll.selectAll;

        let found = true;
         if ((this as any).extensionsList.length > 0) {
          (this as any).extensionsList.forEach(ext => 
          {
              if(!ext.value){
                  found=false;
              }
          });
        }
        return found


        // var allselect=(this as any).extensionsList_selectAll;    
        // allselect=allselect.selectAll;
        // if(allselect)
        // {
        //     return true;
        // }
        // else{
        //    return  false;
        // }
   }
   UnselectAllExtension(){
        let found = 0;
         if (this.extensionsList.length > 0) {
        var extlist=this.extensionsList.forEach(ext => {
                if(ext.value){
                found += 1;
                }
                else{
                    found -= 1;
                }
        });
        }
        if(found==this.extensionsList.length){
         this.$data.selectAll_Extn=true;
        }
   }

   

    toggleExtension(ext: any) {
        const extensions = [...this.extensionsList];
        const thisExt = extensions.filter(e => e.ext === ext)[0];
        this.$store.commit('UPDATE_EXTENSIONS_LIST', {
            extensions
        });
    }

    toggleAllExtensions(e) {
        var extensions = [...this.extensionsList];
        if(arguments.length === 0) {
            this.$data.selected = [];
            this.extensionsList.forEach(ext => {
                this.$data.selected.push(ext);
            });
            return;  
        }
        this.$data.selectAll = e.target.checked ;////!this.$data.selectAll;
        var selectAll=this.$data.selectAll;
        this.$store.commit('UPDATE_EXTENSIONS_LIST_SELECTALL', {  
            selectAll
        });
       this.selectAll_Extn;
        let setValue = false;
        var extensionsList=this.extensionsList
        if (this.$data.selectAll) {
            setValue = true;
        }
        this.extensionsList.forEach(ext => {  
            ext.value = setValue;
        });   
        this.$store.commit('UPDATE_EXTENSIONS_LIST', {
            extensions
        });
    }

    extensionsChanged(selectedItems: any) {
        //alert('extensionsChanged')
        const selectedExtensions = selectedItems.map((e: any) => e.ext);
        const extensions = [...this.extensionsList]
            .map(e => {
                e.value = selectedExtensions.includes(e.ext);
                return e;
            });
        this.$store.commit('UPDATE_EXTENSIONS_LIST', {
            extensions
        });
    }
}
